<script lang="ts">
  import Select from 'svelte-select'

  import { currentQuestion, surveyStatus } from '../../stores'

  const firstAnswer = $surveyStatus.currentUserAnswer[0]
  let current = firstAnswer ? firstAnswer.text : null

  $: {
    $surveyStatus.currentUserAnswer = current
      ? //@ts-ignore
        $currentQuestion.answers.filter((answer) => answer.text === current.value)
      : []

    $surveyStatus = $surveyStatus
  }
</script>

<svelte:window
  on:keydown={(event) => {
    if (event.key === 'ArrowRight' && event.altKey) {
      event.preventDefault()
      current = $currentQuestion.answers[0].text
    }
  }}
/>

<div class="select-question">
  <Select
    items={$currentQuestion.answers.map((answer) => answer.text)}
    bind:value={current}
    placeholder="Seleziona una risposta"
    isVirtualList={true}
    itemFilter={(label, filterText, option) => {
      if (label === 'Altro (specificare)') return true // always include the "Others" label
      label = label.includes('(') ? label.split('(')[0] : label // excludes text after the first "(", like municipality
      return String(label).toLowerCase().includes(filterText.toLowerCase())
    }}
  />

  {#if $surveyStatus.currentUserAnswer[0]?.isOpenAnswer}
    <br />
    <div class="separator" />
    <input
      type="text"
      placeholder="Scrivi la tua risposta..."
      bind:value={$surveyStatus.currentUserAnswer[0].openAnswerText}
      maxlength="100"
    />
  {/if}
</div>

<style>
  .select-question {
    --inputFontSize: 16px;
    --borderRadius: 0;
    --border: 0 0 1px 0;
    --placeholderColor: #7b7b7b;
    --background: transparent;
    --listBackground: #000000;
    --itemIsActiveColor: #00fff0;
    --itemIsActiveBG: transparent;
    --itemHoverColor: #00fff0;
    --itemHoverBG: transparent;
  }

  input[type='text'] {
    height: 25px;
    margin: 0;
    font-size: inherit;
    background-color: transparent;
    border: 0;
    border-bottom: 1px solid white;
    border-radius: 0;
    color: #7b7b7b;
  }
  input[type='text']:focus-visible {
    outline: 0;
  }
</style>
